import React from 'react';
import { Button } from 'antd';
import { useSelector } from 'react-redux';

function ActionButtons({
  isEditing,
  handleEditingAll,
  handleCancel,
  handleSave,
  handleAddNewPhase,
}) {
  const { isClient } = useSelector(({ login }) => ({
    isClient: login.userInfo.role === 'client',
  }));
  return isClient ? (
    <div />
  ) : (
    <div className="action-wrapper role-control">
      {!isEditing ? (
        <Button
          type="primary"
          className="role-control edit-btn"
          onClick={handleEditingAll}
          style={{ textTransform: 'capitalize' }}
        >
          edit
        </Button>
      ) : (
        <>
          <div>
            <Button
              className="dd-cancel-btn"
              onClick={handleCancel}
              style={{ textTransform: 'capitalize' }}
            >
              cancel
            </Button>
            <Button
              className="edit-btn"
              type="primary"
              onClick={handleSave}
              style={{ textTransform: 'capitalize' }}
            >
              save
            </Button>
          </div>
          <div>
            <Button
              className="add-btn dd-cancel-btn"
              onClick={handleAddNewPhase}
              icon={<span className="appkiticon icon-plus-fill" />}
            >
              Add Section
            </Button>
          </div>
        </>
      )}
    </div>
  );
}

export default ActionButtons;
